<template>
    <div class="col-md-12">
		
		<div class="row mb-3 mx-1">
			<h3>Händler Preis Validierung</h3>
		</div>

		<table class="table">
			<thead>
				<tr>
					<th scope="col">Händler</th>
					<th scope="col">Anzahl</th>
					<th scope="col"></th><!-- button -->

				</tr>
			</thead>
			<tbody>
				<tr v-for="itr in untrusted" v-bind:key="itr.vendorId">
					<td>{{itr.name}}</td>
					<td>{{itr.count}}</td>
					<td>
						<button
							type="button"
							class="btn btn-secondary btn-md mx-2"
							@click="() => {  window.location.href = '/vendorpricevalidator/' + itr.vendorId }"
						>
							<span class="icon icon-arrow-right"></span>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		props: [ 'untrusted' ]
	}
</script>
